import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import Icon from '../../components/icons';
import { URLS } from '../../_config';
import { useLocation, useParams } from 'react-router-dom';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import Drawer from '../../components/Drawer';
import Button from '../../components/elements/button';
import { Dropdown, Menu } from '../../components/Dropdown';
import { useWorkRequestApi } from '../../store/api/hooks/workRequestApiHook';
import AssociateWorkOrder from './_components/associateWorkOrder';
import Notes from './_components/notes';
import Attachments from './_components/attachments';
import { getPermissionInfo, showLocalDate } from '../../_common/functions';
import ImpactedAsset from './_components/impactedasset';
import WorkFiles from './_components/workFiles';
import CreateWorkRequest from './_components/createWorkRequest';
import { useAppLoader } from '../../_common/pageLoader/appLoaderHook';
import CreateWorkOrder from '../WorkOrder/_components/createWorkOrder';
import { useChecklistApi } from '../../store/api/hooks/checklistApiHook';
import { useUserSelector } from '../../store/selectors/userSelector';

const WorkRequestDetails: React.FC = () => {
    const [tab, setTab] = useState('general');
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
    const checklistAPI: any = useChecklistApi();

    const workRequestAPI: any = useWorkRequestApi();
    const addNewAssetRef: any = React.createRef<HTMLButtonElement>();
    const [asset, setAsset] = useState<any>(null)
    const WorkOrder = useRef<any>();
    const wrfilesRef = useRef<any>();
    const createDrawerRef: any = useRef();
    const createFacilityRef: any = useRef();
    const createWORef: any = useRef();
    const createDrwerWORef: any = useRef();

    const { showLoader, hideLoader } = useAppLoader();
    const [editData, setEditData] = useState<any>(null);
    const location = useLocation();
    const loggedinuser: any = useUserSelector();

    const GetWorkRequestByID = (assetID: any) => {
        const payload = {
            WorkRequestID: assetID
        }
        showLoader();
        workRequestAPI.GetWorkRequestByID(payload, async (data: any) => {
            hideLoader();
            var woassetsmap = [];
            var checklistmap: any = [];
            if (data?.workRequestMappingList && Array.isArray(data?.workRequestMappingList)) {
                woassetsmap = data?.workRequestMappingList.map((item: any) => {
                    return {
                        woAssetMappingID: item?.wrAssetMappingID,
                        workOrderID: null,
                        assetID: item?.assetID,
                        assetCode: item?.assetCode,
                        name: item?.assetName,
                        statusID: item?.statusID,
                        statusName: item?.statusName,
                        vehicleLastInspection: item?.vehicleLastInspection,
                        warrantyEndDate: item?.warrantyEndDate
                    }
                });

                var assetIDs: any = data?.workRequestMappingList.map((o: any) => o.assetID);
                if (assetIDs.length > 0) {
                    checklistmap = await new Promise((resolve, reject) => {
                        checklistAPI.getChecklists({ assetIDs: assetIDs }, (resp: any) => {
                            if (resp && resp.hasOwnProperty('checklistList') && Array.isArray(resp.checklistList) && resp.checklistList.length > 0) {
                                resolve(resp.checklistList);
                            } else {
                                resolve([]);
                            }
                        }, (error: any) => {
                            reject([]);
                        });
                    }).catch((error: any) => { });
                }
            }

            const wrimagesresp = await new Promise((resolve, rejects) => {
                workRequestAPI.GetWorkRequestImages({ workRequestID: assetID }, (resp: any) => {
                    resolve((resp && resp?.files) ? resp?.files : []);
                }, (error: any) => {
                    rejects([]);
                });
            }).catch((error: any) => { });



            data[`prefillData_wo`] = {
                model: {
                    workRequestID: data?.workRequestID,
                    description: data?.description,
                    facilityID: data?.facilityID,
                    subFacilityID: data?.subFacilityID,
                    workRequestPriorityID: data?.workRequestPriorityID,
                },
                assets: woassetsmap,
                checklist: checklistmap,
                images: wrimagesresp
            };
            console.log("WR data ->", data);
            setAsset(data);

        }, (error: any) => {
            hideLoader()
        });
    };

    useEffect(() => {
        if (params.id) {
            GetWorkRequestByID(params.id);
        }
    }, [params]);

    return (
        <Layout>
            <Header title={asset?.workRequestCode} back={URLS.WORK_REQUEST}>
                <Header.Right>
                    <div className={ `mr-2` }>
                        {asset?.workRequestStatusName && (
                            <div className={`flex items-center gap-2`} style={{ border: `1px solid ${asset?.workRequestStatusHexCode || `#ccc`}`, padding: `8px 10px`, borderRadius: `5px`}}>
                                <span style={{ 
                                    width: `12px`, 
                                    height: `12px`, 
                                    borderRadius: `12px`, 
                                    display: `flex`, 
                                    alignItems: `center`, 
                                    justifyContent: `center`,
                                    backgroundColor: asset?.workRequestStatusHexCode || `#333333`,
                                }}></span>                            
                                <span className='rounded-md' style={{ fontSize: `14px`, color: '#000000', fontWeight: `400` }}>
                                    {asset?.workRequestStatusName}
                                </span>
                            </div>
                        )}                              
                    </div>
                    <Button disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)} theme='light' onClick={() => {
                        setEditData(asset);
                        createDrawerRef?.current?.open()
                    }} >Edit
                    </Button>
                    <Drawer _ref={createDrawerRef} onClose={() => {
                        console.log('close drawer', createFacilityRef?.current?.reset);
                        createFacilityRef?.current?.reset()
                        setEditData(null)
                    }} outsideClose={false}>
                        <Drawer.Button>
                            {/* <Button>Create New Request</Button> */}
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Work Request' : 'Create New Work Request'} className='!w-[39.563rem]'>
                            <CreateWorkRequest _ref={createFacilityRef} editData={editData} onCreate={() => {
                                setEditData(null);
                                GetWorkRequestByID(params.id);                                                                
                                if (wrfilesRef?.current && wrfilesRef?.current?.reload) {
                                    wrfilesRef?.current?.reload();
                                }
                                createDrawerRef?.current?.close();
                            }} onCancel={() => {
                                setEditData(null);
                                GetWorkRequestByID(params.id);                               
                                if (wrfilesRef?.current && wrfilesRef?.current?.reload) {
                                    wrfilesRef?.current?.reload();
                                }
                                createDrawerRef?.current?.close()
                            }} />
                        </Drawer.Content>
                    </Drawer>

                    <Drawer _ref={createDrwerWORef} isAfterOpenRender={true} onClose={() => {
                        console.log('close drawer', createFacilityRef?.current?.reset);
                        GetWorkRequestByID(params.id);
                        setEditData(null);
                        createDrwerWORef?.current?.close();
                        createWORef?.current?.reset()
                        createWORef?.current?.reset_re_render_vars();
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, "Add", loggedinuser)}>Create New Task</Button>
                        </Drawer.Button>
                        <Drawer.Content title={`Create New Task`} className='!w-[39.563rem]'>
                            <CreateWorkOrder _ref={createWORef} editData={null} WrID={params.id} prefillData={asset?.prefillData_wo || null} onCreate={() => {
                                setEditData(null);
                                setAsset(null);
                                GetWorkRequestByID(params.id);
                                createDrwerWORef?.current?.close();
                                if (WorkOrder?.current && WorkOrder?.current?.reload) {
                                    WorkOrder?.current?.reload()
                                }
                            }} onCancel={() => {
                                setEditData(null);
                                setAsset(null);
                                GetWorkRequestByID(params.id);
                                createDrwerWORef?.current?.close();
                                if (WorkOrder?.current && WorkOrder?.current?.reload) {
                                    WorkOrder?.current?.reload()
                                }
                            }} />
                        </Drawer.Content>
                    </Drawer>
                    {/*
                    <Dropdown>
                        <Dropdown.Button>
                         <button className='bg-white border border-gray-400 text-black text-sm px-5 py-3 rounded-md font-bold hover:bg-[#f3f3f3] shadow-md'> ⋮ </button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            <Menu onClick={onBulkPrintQR}>Move Assets</Menu>
                            <Menu onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu onClick={onBulkExportPdf}>Export pdf</Menu>                            
                        </Dropdown.Content>
                    </Dropdown>
                    */}
                </Header.Right>


            </Header>


            <div className='px-5'>
                
                <div className="rounded-md border border-gray-300 mt-10">
                    <div className="grid grid-cols-12 gap-1" style={{ background: '#f0f0f0', minHeight: '50px' }}>
                        <div className={ `col-span-6 px-3 py-2 flex items-center` } style={{ minHeight: '50px' }}>
                            <label className="font-medium text-slate-600" style={{ fontSize: `14px`}}>Description</label>
                        </div>
                        <div className={ `col-span-6 px-3 py-2 flex items-center` } style={{ minHeight: '50px' }}>
                            <label className={ `text-[0.75rem] font-medium text-slate-600` } style={{ fontSize: `14px`}}>Notes</label>
                        </div>
                    </div>

                    <div className={ `grid grid-cols-12 gap-1` }>
                        <div className={ `col-span-6 px-3 py-2 border-r` } style={{ fontSize: `15px`, color: `#42484B` }}>
                            {asset?.description || `--`}
                        </div>
                        <div className={ `col-span-6 px-2 py-2` } style={{ fontSize: `15px`, color: `#42484B` }}>
                            {asset?.notes || `--`}
                        </div>
                    </div>
                </div>
                
                <div className="rounded-md border border-gray-300 mt-5">
                    <div className="grid grid-cols-12 gap-1" style={{ background: '#f0f0f0', minHeight: '50px' }}>
                        <div className={ `col-span-6 px-3 py-2 flex items-center` } style={{ minHeight: '50px' }}>
                            <label className="font-medium text-slate-600" style={{ fontSize: `14px`}}>Facility</label>
                        </div>
                        <div className={ `col-span-6 px-3 py-2 flex items-center` } style={{ minHeight: '50px' }}>
                            <label className={ `text-[0.75rem] font-medium text-slate-600` } style={{ fontSize: `14px`}}>Sub- Facility</label>
                        </div>
                    </div>

                    <div className={ `grid grid-cols-12 gap-1` }>
                        <div className={ `col-span-6 px-3 py-2 border-r` } style={{ fontSize: `15px`, color: `#42484B` }}>
                            {asset?.facilityName || `--`}
                        </div>
                        <div className={ `col-span-6 px-2 py-2` } style={{ fontSize: `15px`, color: `#42484B` }}>
                            {asset?.wrSubFacilityNames || `--`}
                        </div>
                    </div>
                </div>

                <div className="rounded-md border border-gray-300 mt-5">
                    <div className="grid grid-cols-12 gap-1" style={{ background: '#f0f0f0', minHeight: '50px' }}>
                        <div className={ `col-span-6 px-3 py-2 flex items-center` } style={{ minHeight: '50px' }}>
                            <label className="font-medium text-slate-600" style={{ fontSize: `14px`}}>Priority</label>
                        </div>
                        <div className={ `col-span-6 px-3 py-2 flex items-center` } style={{ minHeight: '50px' }}>
                            <label className={ `text-[0.75rem] font-medium text-slate-600` } style={{ fontSize: `14px`}}>Reported By</label>
                        </div>
                    </div>

                    <div className={ `grid grid-cols-12 gap-1` }>
                        <div className={ `col-span-6 px-3 py-2 border-r` } style={{ fontSize: `15px`, color: `#42484B` }}>
                            {asset?.workRequestPriorityName || `--`}
                        </div>
                        <div className={ `col-span-6 px-2 py-2` } style={{ fontSize: `15px`, color: `#42484B` }}>
                            {asset?.requsterName || `--`} {asset?.incidentDate? showLocalDate(asset?.incidentDate): ``}
                        </div>
                    </div>
                </div>  

                {/*
                <div className="rounded-md border border-gray-300 mt-5">
                    <div className="grid grid-cols-12 gap-1 bg-gray-100">
                        <div className="col-span-6 px-2 leading-10 ">
                            <label className="text-[0.75rem] font-medium text-slate-600">Priority</label>
                        </div>
                        <div className="col-span-6 px-2 leading-10">
                            <label className="text-[0.75rem] font-medium text-slate-600">Reported By</label>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-1 text-slate-800">
                        <div className="col-span-6 px-2 leading-10 flex items-center">
                            {asset?.workRequestPriorityName}
                        </div>
                        <div className="col-span-6 px-2 leading-10 flex items-center">
                            {asset?.requsterName} {showLocalDate(asset?.incidentDate)}
                        </div>
                    </div>
                </div>
                */}

                <WorkFiles _ref={ wrfilesRef } />                
                <AssociateWorkOrder _ref={WorkOrder} />
                <ImpactedAsset details={asset} />
                <Notes canAddNotes={getPermissionInfo(location.pathname, "Attach additional notes", loggedinuser)} />
                <Attachments />
            </div>
        </Layout>
    );
};

export default WorkRequestDetails;